import { isValidOrgNo } from 'se-org-no'

export const slugFromKey = key => {
  if (key) {
    return key.toLowerCase().replace(/_/g, '-')
  }
  return ''
}

export const slugFromName = name => {
  if (name) {
    return name.toLowerCase()
      .replace(/ & /g, '-')
      .replace(/ /g, '-')
      .replace(/&/g, '-')
      .replace(/å/, 'a')
      .replace(/ä/, 'a')
      .replace(/ö/, 'o')
  }
  return ''
}

export const getOrgFormat = value => {
  return value.length === 10 && isValidOrgNo(value) ? `${value.substring(0, 6)}-${value.substring(6)}` : value
}
